var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.75 26.7188C28.0625 27.0312 28.0625 27.5 27.75 27.7812C27.625 27.9375 27.4375 28 27.25 28C27.0312 28 26.8438 27.9375 26.6875 27.7812L22.5 23.5938C21.375 24.5 19.9688 25 18.4688 25C14.9062 25 12 22.0938 12 18.5C12 14.9375 14.875 12 18.4688 12C22.0312 12 24.9688 14.9375 24.9688 18.5C24.9688 20.0312 24.4688 21.4375 23.5625 22.5312L27.75 26.7188ZM13.5 18.5C13.5 21.2812 15.7188 23.5 18.5 23.5C21.25 23.5 23.5 21.2812 23.5 18.5C23.5 15.75 21.25 13.5 18.5 13.5C15.7188 13.5 13.5 15.75 13.5 18.5Z",
    fill: "#5F6774"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.8a2d2754adb912715d20224ffe7ac798.svg";
export { ForwardRef as ReactComponent };